"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/RoomHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);








const RoomHeader = ({
  roomName, roomLink, onRoomLinkCopy, openMobileMoreOptionsModal,
}) => (
  _react2.default.createElement('div', { className: "video-call--room-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement('div', { className: "video-call--room-header--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('h3', { className: "video-call--room-header--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}},  roomName )
      , _react2.default.createElement('a', { className: "video-call--room-header--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 17}},  roomLink )
      )
    )
    , _react2.default.createElement('div', { className: "video-call--room-header--controls-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
      , _react2.default.createElement('div', { className: "video-call--room-header--controls-icon", onClick: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
        , _react2.default.createElement('img', { src: "/assets/icons/video/link-black.svg", alt: "🔗", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}} )
      )
      , _react2.default.createElement('div', {
        className: "video-call--room-header--controls-icon",
        onClick: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}

        , _react2.default.createElement('img', { src: "/assets/icons/video/more-black.svg", alt: "⋮", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}} )
      )
    )
  )
)

exports. default = RoomHeader
